// extracted by mini-css-extract-plugin
export default {"picture":"foub5FN6Jic"};